import script from "./checkbox-list-with-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkbox-list-with-search.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__